<template>
  <div>
    <el-table :data="projectList" height="calc(100vh - 300px)">
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="租户">
        <template slot-scope="scope">{{ scope.row.tenantName }}</template>
      </el-table-column>
      <el-table-column label="意见">
        <template slot-scope="scope">{{ scope.row.userView }}</template>
      </el-table-column>
      <el-table-column label="联系方式">
        <template slot-scope="scope">{{ scope.row.contact }}</template>
      </el-table-column>
      <el-table-column prop="userDescribe" label="描述"></el-table-column>

      <el-table-column label="图片">
        <template slot-scope="scope">
          <img class="image" :src="scope.row.image" alt="" />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">{{
          scope.row.status == false ? '未处理' : '已处理'
        }}</template>
      </el-table-column>

      <!--  <el-table-column prop="finished" label="完成状态">
        <template slot-scope="scope">{{
          scope.row.finished ? '已处理' : '未处理'
        }}</template>
      </el-table-column>
      <el-table-column
        prop="fromAccountOrAddress"
        label="from地址"
      ></el-table-column>
      <el-table-column prop="hash" label="hash"></el-table-column>
      <el-table-column label="to地址">
        <template slot-scope="scope">
          <a
            class="link"
            target="_blank"
           
            >{{ scope.row.toAddress }}</a
          >
       
        </template>
      </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="区块状态"></el-table-column> -->

      <el-table-column label="操作" width="250px">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status === false"
            @click="cancelBlack(true, scope.row.id)"
            >修改状态</el-button
          >
          <el-button
            type="text"
            size="small"
            class="del"
            v-if="scope.row.status === false"
            @click="del(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
import api from '../../api'
export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
    }
  },
  computed: {
    ...mapState('feedback', ['pagination', 'totalCount', 'auditList']),
    ...mapGetters('feedback', ['projectList']),
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('feedback', ['list', 'setPass']),
    ...mapMutations('feedback', ['setpage']),
    handleCurrentChange(pagination) {
      this.setpage(pagination)
      this.$emit('refresh', { pagination, type: 1 })
    },
    cancelBlack(isPass, id) {
      const action = isPass
        ? this.$confirm('确定处理该意见吗？', '提示', {
            type: 'warning',
          })
        : this.$confirm('确定审核不通过吗？', '提示', {
            type: 'warning',
          })
      action.then(({ value }) => {
        this.setPass({
          id: id,
          auditStatus: isPass ? 1 : 2,
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！',
            })
          })
          .finally(() => {
            this.list({ page: 1 })
          })
      })
    },
    del(id) {
      this.$confirm('确定删除吗？', '提示', {
        type: 'warning',
      }).then(({ value }) => {
        api
          .delete({ id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.list({ page: 1 })
            }
          })
          .catch((err) => {
            this.$message.success('操作失败！')
          })
      })
    },
    open(coin, toAddress, hash) {
      window.open(
        '#/home/audit/deposite/records?coin=' +
          coin +
          '&toAddress=' +
          toAddress +
          '&hash=' +
          hash
      )
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  text-decoration: underline;
  cursor: pointer;
  color: #409eff;
}
.image {
  width: 200px;
}
.del {
  color: #f54a45;
}
</style>
